import * as React from "react";
import { useContext } from "react";
import StreamsContext from "contexts/StreamsContext";
import UserHasNoStreamAccess from "pages/UserHasNoStreamAccess";
export default ({ children, skipNoStreamsCheck = false }) => {
  const streams = useContext(StreamsContext);
  if (skipNoStreamsCheck) {
    return children;
  }
  return streams && streams.length > 0 ? children : /* @__PURE__ */ React.createElement(UserHasNoStreamAccess, null);
};
